import React, { useEffect, useState } from "react";
import DetailLayout from "../../../../components/DetailLayout";
import Header from "./components/Header";
import style from "./index.module.scss";
import QuestionnaireBar from "../QuestionnaireBar";
import { Button } from "antd";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import {
    QuestionnaireProps,
    PaperProps,
    TopicsItem,
    BaseQuestionType
} from "../../../service";
import PageRadioDetail from "./components/PageRadioDetail";
import PageCheckBoxDetail from "./components/PageCheckBoxDetail";
import PageSubjectiveDetail from "./components/PageSubjectiveDetail";

interface DetailPCProps {
    data: PaperProps;
    headerData: QuestionnaireProps;
}

export default function QuestionnaireDetailPC({
    data,
    headerData
}: DetailPCProps) {
    const [checked, setChecked] = useState(1); //当前选中
    const [currentData, setCurrentData] = useState<TopicsItem>(); //选中的试题对象

    useEffect(() => {
        if (data) {
            setCurrentData(
                data.topics.find((item, index) => index + 1 === checked)
            );
        }
    }, [data, checked]);

    return (
        <DetailLayout breadcrumb="问卷详情">
            <Header headerData={headerData} />

            <div className={style.main}>
                <div className={style.left}>
                    {data && (
                        <QuestionnaireBar
                            checked={checked}
                            data={data.topics}
                            onChange={(val: number) => setChecked(val)}
                        />
                    )}
                </div>

                <div className={style.right}>
                    {currentData &&
                        currentData.queTypeId ===
                            BaseQuestionType.SingleChoice &&
                        checked === currentData.index && (
                            <PageRadioDetail data={currentData} />
                        )}
                    {currentData &&
                        currentData.queTypeId ===
                            BaseQuestionType.MultipleChoice &&
                        checked === currentData.index && (
                            <PageCheckBoxDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId === BaseQuestionType.Subjective &&
                        checked === currentData.index && (
                            <PageSubjectiveDetail data={currentData} />
                        )}

                    <div className={style.footer}>
                        {currentData && currentData.index !== 1 && (
                            <Button
                                className={style.prev}
                                onClick={() =>
                                    setChecked(currentData.index - 1 || 1)
                                }>
                                <AiOutlineLeftCircle />
                                上一题
                            </Button>
                        )}
                        {currentData &&
                            data &&
                            currentData.index !== data.topics.length && (
                                <Button
                                    className={style.next}
                                    onClick={() =>
                                        setChecked(currentData.index + 1 || 1)
                                    }>
                                    下一题
                                    <AiOutlineRightCircle />
                                </Button>
                            )}
                        {currentData &&
                            data &&
                            currentData.index === data.topics.length && (
                                <div className={style.lastDiv}>
                                    已是最后一题了
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </DetailLayout>
    );
}
